
import {
  DEBUGGER_RECEIVE_EVENT,
  DEBUGGER_RECEIVE_HISTORICAL_EVENT,
  DEBUGGER_RECEIVE_ERROR,
  DEBUGGER_RECEIVE_HISTORICAL_ERROR,
  DEBUGGER_TICK,
  DEBUGGER_PAUSED,
  DEBUGGER_RESUMED,
  DEBUGGER_SET_MEMORY_LIMIT
} from 'actions'

/**
 * Max number of timeline records we'll keep in memory.
 */

export const MAX_TIMELINE = 220

export const initialState = {
  // events that were received between "ticks"
  pendingEvents: [],
  // rendered events
  events: [],
  // number of events that came in on a certain "tick"
  timeline: [],
  // meta
  isPaused: false,
  max_events: 500
}

export default function (state = initialState, { type, payload }) {
  const { pendingEvents, events, timeline } = state
  const MAX_EVENTS = state.max_events
  const nextEvents = []
  const nextTimeline = []

  switch (type) {
    case DEBUGGER_RECEIVE_EVENT:
    // when paused, don't accept new events
      if (state.isPaused) {
        return state
      }

    // remove the last event if we've reached our limit
      if (pendingEvents.length >= MAX_EVENTS) {
        pendingEvents.pop()
      }

    // add the pending event
      return {
        ...state,
        pendingEvents: [
          payload.event,
          ...pendingEvents
        ]
      }
    case DEBUGGER_RECEIVE_HISTORICAL_EVENT:
    // immediately add historical events (make it look faster than it really is)
      nextEvents.push(payload.event)
      nextEvents.push(...events)
      return {
        ...state,
        events: nextEvents.slice(0, MAX_EVENTS)
      }

    case DEBUGGER_RECEIVE_HISTORICAL_ERROR:
    case DEBUGGER_RECEIVE_ERROR:
      return {
        ...state,
        pendingEvents: error(pendingEvents, payload.error),
        events: error(events, payload.error)
      }

    case DEBUGGER_TICK:
    // add new events + old events
      nextEvents.push(...pendingEvents)
      nextEvents.push(...events)
    // add old timeline + new timline
      nextTimeline.push(...timeline)
      nextTimeline.push(pendingEvents.length)
      return {
        ...state,
      // add the "next" events, keeping previous events (up to MAX_EVENTS)
        events: nextEvents.slice(0, MAX_EVENTS),
      // empty the pending bucket
        pendingEvents: [],
      // add the "next" timeline, but limit to the max
        timeline: nextTimeline.slice(-MAX_TIMELINE)
      }
    case DEBUGGER_PAUSED:
    case DEBUGGER_RESUMED:
      return { ...state, isPaused: !state.isPaused }
    case DEBUGGER_SET_MEMORY_LIMIT:
      return {
        ...state,
        max_events: parseInt(payload, 10)
      }
    default:
      return state
  }
}

/**
 * Add `error` to the given `eventList`.
 */

function error (eventList, error) {
  const { messageId } = error
  // add to pending
  for (let i = 0; i < eventList.length; i++) {
    if (eventList[i].id === messageId) {
      eventList[i].errors.push(error)
    }
  }
  return eventList
}



// WEBPACK FOOTER //
// ./reducers/source-debugger.js